import styled from 'styled-components';

const EditorStyle = styled.div`
	h5 {
		font-size: var(--h5);
		font-family: var(--minion3Font);
		font-weight: 500;
		color: var(--primaryColor9);
		line-height: var(--lineHeightH5);
	}

	h6 {
		font-size: var(--h6);
		font-family: var(--minion3Font);
		font-weight: 500;
		color: var(--primaryColor9);
		line-height: var(--lineHeightH6);
	}

	p {
		font-size: var(--p3);
		font-family: var(--notoSansFont);
		font-weight: 400;
		color: var(--primaryColor1);
		line-height: var(--lineHeightP3);
	}

	ul {
		li {
			width: 100%;
			display: inline-flex;
			align-items: center;
			font-size: var(--p3);
			font-family: var(--notoSansFont);
			font-weight: 400;
			line-height: var(--lineHeightP3);
			color: var(--primaryColor1);

			&:before {
				content: '';
				display: block;
				width: 100%;
				max-width: var(--sp1x);
				height: var(--sp1x);
				border-radius: 50%;
				background-color: var(--primaryColor1);
				margin-right: var(--sp2x);
			}
		}
	}

	strong,
	i {
		font-size: var(--p3);
		line-height: var(--lineHeightP3);
		color: var(--primaryColor1);
	}

	ol {
		margin-block-start: 0;
		margin-block-end: 0;
		padding-inline-start: 1.5em;

		li {
			font-size: var(--p3);
			font-family: var(--notoSansFont);
			font-weight: 400;
			line-height: var(--lineHeightP3);
			color: var(--primaryColor1);
		}
	}

	blockquote {
		border-left: 5px solid var(--primaryColor1);
		font-size: var(--p3);
		line-height: var(--lineHeightP3);
		font-family: var(--notoSansFont);
		font-weight: 400;
		color: var(--primaryColor1);
		margin-block-start: 0;
		margin-block-end: 0;
		margin-inline-start: 0;
		margin-inline-end: 0;

		p {
			margin-left: var(--largeDistance);
		}
	}

	a {
		font-family: var(--notoSansFont);
		font-weight: 500;
		font-size: var(--p3);
		line-height: var(--lineHeightP3);
		text-decoration: underline;
		color: var(--primaryColor1);
		transition: color var(--trTime);

		@media (pointer: fine) {
			@media (hover: hover) {
				&:hover {
					color: var(--primaryColor9);
				}
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
		--largeDistance: var(--sp3x);
		--smallDistance: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
		--largeDistance: var(--sp3x);
		--smallDistance: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		--largeDistance: var(--sp3x);
		--smallDistance: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		--largeDistance: var(--sp3x);
		--smallDistance: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		--largeDistance: var(--sp3x);
		--smallDistance: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		--largeDistance: var(--sp3x);
		--smallDistance: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--largeDistance: var(--sp3x);
		--smallDistance: var(--sp2x);
	}
`;

export default EditorStyle;
